var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGearSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 78,
    viewBox: "0 0 80 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7049 63.9442C53.744 63.9442 65.1249 52.5633 65.1249 38.5242C65.1249 24.4852 53.744 13.1042 39.7049 13.1042C25.6658 13.1042 14.2849 24.4852 14.2849 38.5242C14.2849 52.5633 25.6658 63.9442 39.7049 63.9442Z",
    fill: "#B48DAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1772 43.8215L79.1194 41.1165L76.4144 25.1744L60.4722 27.8794L63.1772 43.8215Z",
    fill: "#B48DAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6242 59.6804L58.3623 72.5893L71.2711 62.8512L61.533 49.9423L48.6242 59.6804Z",
    fill: "#B48DAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9773 57.3217L20.7502 72.6236L36.0521 77.8506L41.2792 62.5488L25.9773 57.3217Z",
    fill: "#B48DAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6161 36.54L0 40.736L4.19601 56.3521L19.8121 52.156L15.6161 36.54Z",
    fill: "#B48DAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6888 6.1779L45.387 0.950836L40.1599 16.2527L55.4618 21.4798L60.6888 6.1779Z",
    fill: "#B48DAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4497 16.3308L22.1904 3.83215L9.69174 14.0914L19.951 26.5901L32.4497 16.3308Z",
    fill: "#B48DAF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3148 47.3442C44.2522 47.3442 48.2548 43.3417 48.2548 38.4042C48.2548 33.4668 44.2522 29.4642 39.3148 29.4642C34.3773 29.4642 30.3748 33.4668 30.3748 38.4042C30.3748 43.3417 34.3773 47.3442 39.3148 47.3442Z",
    fill: "#2E1926"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearSmall);
export default __webpack_public_path__ + "static/media/gear_small.cc7ac3bd5a5034c3ff64a8cb9a6e7f83.svg";
export { ForwardRef as ReactComponent };